import type { ColDef } from 'ag-grid-community'

import { QRADatasetRowEntry, QRARowEntryCRID } from '$/types'
import { IGetQRATableQueryParams } from 'app/services/api/qra/datatable'
import { JobMutationTrigger } from 'common/contexts/types'

export enum QRATableLineViewMode {
  Output,
  Input
}

interface ITableViewProps<Y = object> {
  showLoading?: boolean
  colDefs: ColDef[]
  rowData?: QRADatasetRowEntry<Y>[]
  rowSelectCB?: (rowData: QRADatasetRowEntry<Y>) => void
  groupColumns: IGroupColumnsSelection[]
  setGroupColumns: (group: IGroupColumnsSelection[]) => void
}

export interface ISystemTableViewProps
  extends ITableViewProps<QRARowEntryCRID> {
  exportParams: IGetQRATableQueryParams
  mutationTrigger: JobMutationTrigger
  fileName?: string
}

export interface ILineTableViewProps extends ITableViewProps {
  lineViewMode: QRATableLineViewMode
  s1Label: string | undefined
  setLineViewMode: (lineViewMode: QRATableLineViewMode) => void
  exportParams: IGetQRATableQueryParams
  mutationTrigger: JobMutationTrigger
  fileName?: string
  units: Record<string, string>[]
  isCompareView?: boolean
}

/**
 * QRA Output/Input Table Group/Configure Columns selection
 * Group columns shall be implemented as ordered list of configure columns
 */

export interface IGroupColumnsSelection {
  /**
   * Category/Threat Id
   */
  id: number
  /**
   * Category/Threat Name
   * REVIEW: Retrieve this from look up table instead?
   */
  name: string
  /**
   * Columns Names
   * `undefined` shall indicate that no selection has been made (so we show all)
   * TODO: Needs to be restructured to a data structure that the backend expects
   */
  groupTypeColumns: string[] | undefined
}

/**
 * Data structure used in group columns popup to monitor which which attributes/categories are toggled on
 * Similar to IConfigureColumnsSelection interface but has additional 'checked' properties that dictate how the UI is rendered
 */
export interface IGroupColumnsSelectionWithToggles
  extends Omit<IGroupColumnsSelection, 'groupTypeColumns'> {
  groupTypeColumns: ICheckedAttributes[]
  /**
   * Monitors whether the category is toggled on
   */
  isActive: boolean
  order: number
}

export interface ICheckedAttributes {
  name: string
  /**
   * Monitors whether an attribute within a category is selected
   */
  isSelected: boolean
}
